// Firebase app configuration.
const config = {
    // Past your configuration here from Google Firebase
    apiKey: "AIzaSyAnfbUe0zXqkdACvQCyFKQTIHb8Hqxkjp8",
    authDomain: "eprojektant-1aad2.firebaseapp.com",
    databaseURL: "https://eprojektant-1aad2.firebaseio.com",
    projectId: "eprojektant-1aad2",
    storageBucket: "eprojektant-1aad2.appspot.com",
    messagingSenderId: "987992049786"
}

export default config;



// WEBPACK FOOTER //
// ./src/firebase/config.js